export default __webpack_public_path__ + "static/media/m1.1b10eecb.png";